import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    SName:"",
}

const ANameSlice = createSlice({
    name: "ANameSlice",
    initialState,

    reducers: {
        ANameData(state, action) {
            return {
                SName:action.payload.SName,
            };
        }
    }
})
export const { ANameData } = ANameSlice.actions;
export default ANameSlice.reducer;